<template>
  <div class="bg-white">
    <CoverPage />

    <AboutUs />
    <div class="abtus-bg">
      <Achievements />
    </div>
    <Team />
    <LegalDocu />
    <div class="w-full">
      <Counters />
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import Counters from "./components/Counters.vue";
import CoverPage from "./components/CoverPage.vue";
import AboutUs from "./components/AboutUs.vue";
import Achievements from "./components/Achievements.vue";

import Team from "./components/Team.vue";
import LegalDocu from "./components/LegalDocu.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";

export default {
  components: {
    CoverPage,
    AboutUs,
    Achievements,
    Counters,

    Team,
    LegalDocu,
    DownloadApp,
    Footer,
  },
  metaInfo: {
    title: "Abouts us: Caregiver Saathi Foundation",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Caregiver Saathi addresses the needs of the caregiver and their well-being. We offer  community support, counselling sessions and home-care services",
      },
    ],
  },
};
</script>
